import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {DataService} from '../../services/data.service';
import {SurveyInformation} from '../evaluation-form/survery-information';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SurveryEvaluationService extends DataService {
  surveyNoInit: any = {};
  private surveyNoSource = new BehaviorSubject<any>(this.surveyNoInit);
  currentSurveyNo = this.surveyNoSource.asObservable();
  private surveryURI = this.publicApiUri + '/hhg3080survey';
  private scacURI = this.publicApiUri + '/carrier/scac/HHG/list';
  private scacFRTURI = this.publicApiUri + '/carrier/scac/FRT/list';
  private saveSurveyURI = this.publicApiUri + '/hhg3080survey/submitResponse';
  private initiateSurveyURI = this.publicApiUri + '/hhg3080survey/initiateSurvey';
  private surveyBolURI = this.publicApiUri + '/hhg3080survey/getSurveyBol/';
  private surveyActionURI = this.publicApiUri + '/hhg3080survey/adminAction/';
  private surveyAuditURI = this.apiUri + '/auditTrail/';
  private hasRecord = this.publicApiUri + '/hhg3080survey/isExistingSurvey/';
  private surveyEmpLastNameURI = this.publicApiUri + '/hhg3080survey/getSurveybyEmpLastName/';
  constructor(http: HttpClient) {
    super(http);
  }
  getSurveyInformation(surveyNo) {
    return this.http.get<SurveyInformation>(this.surveryURI + '/getSurvey/' + surveyNo);
  }
  getScac() {
    return this.http.get<any>(this.scacURI);
  }

  isExistingSurvey(empLastName: string) {
    return this.http.get<boolean>(this.hasRecord + empLastName);
  }

  getSurveyByEmplLastName(empLastName: string) {
    return this.http.get<any>(this.surveyEmpLastNameURI + empLastName);
  }

  getFRTScac() {
    return this.http.get<any>(this.scacFRTURI);
  }

  saveSurvey(surveyInfo: SurveyInformation) {
    return this.http.post(this.saveSurveyURI, surveyInfo);
  }
  initiateSurvey(initialSurveyInfo: SurveyInformation) {
    return this.http.post(this.initiateSurveyURI, initialSurveyInfo);
  }
  // using this to avoid local storage
  setSurveyNo(data: any) {
    this.surveyNoSource.next(data);
  }

  // using this to avoid local storage
  getSurveyNo() {
    return this.currentSurveyNo;
  }
  getSurveyBol(bolNumber) {
    return this.http.get(this.surveyBolURI + bolNumber);
  }

  surveyAction(actionType, payLoad) {
    return this.http.post(this.surveyActionURI + actionType, payLoad);
  }

  surveyHistory(surveyId) {
    return this.http.get(this.surveyAuditURI + surveyId + '/surveyId');
  }
}
